import { render, staticRenderFns } from "./bagBoard.vue?vue&type=template&id=2c42d5e6&scoped=true&"
import script from "./bagBoard.vue?vue&type=script&lang=js&"
export * from "./bagBoard.vue?vue&type=script&lang=js&"
import style0 from "./bagBoard.vue?vue&type=style&index=0&id=2c42d5e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c42d5e6",
  null
  
)

export default component.exports